import { useTranslation } from 'react-i18next';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { ControlledTextField } from 'components/shared/ControlledFields';

const CommentsSection = ({ control }) => {
  const { t } = useTranslation('common');

  return (
    <>
      <MultiStepForm.Section
        title={t('travelArrangements.comments')}
        validateFields={['comment']}
      >
        <ControlledTextField
          name="comment"
          type="text"
          control={control}
          variant="outlined"
          label={t('travelArrangements.comments')}
        />
      </MultiStepForm.Section>
    </>
  );
};

export default CommentsSection;
